import PropTypes from 'prop-types';
import { JOB_EVENT_TYPES } from './config';
import AddedToJob from './addedToJob';
import Disqualified from './disqualified';
import Requalified from './requalified';
import StepChange from './stepChange';

const JOB_EVENT_COMPONENTS = {
  [JOB_EVENT_TYPES.ADDED_TO_JOB]: AddedToJob,
  [JOB_EVENT_TYPES.DISQUALIFIED]: Disqualified,
  [JOB_EVENT_TYPES.REQUALIFIED]: Requalified,
  [JOB_EVENT_TYPES.MOVED_STEP]: StepChange,
};

const JobEvent = ({ translations, record }) => {
  const EventComponent = JOB_EVENT_COMPONENTS[record.event_type];

  if (!EventComponent) {
    return null;
  }

  return <EventComponent translations={translations} record={record} />;
};

JobEvent.propTypes = {
  translations: PropTypes.shape({}).isRequired,
  record: PropTypes.object.isRequired,
};

export default JobEvent;
